import LandingHeader from "../components/Landing/sections/LandingHeader.jsx";
import LandingNav from "../components/Landing/sections/LandingNav.jsx";
import HeroSection from "../components/Landing/sections/HeroSection.jsx";
import MarqueeBar from "../components/Landing/sections/MarqueeBar.jsx";
import ThreeExperiences from "../components/Landing/sections/ThreeExperiences.jsx";
import GetStarted from "../components/Landing/sections/GetStarted.jsx";
import LandingFooter from "../components/Landing/sections/LandingFooter.jsx";

import "../styles/new-landing.css";

const LandingPage = () => {
  return (
    <div className="landing-page-new">
      <LandingHeader />
      <LandingNav />
      <HeroSection />
      <MarqueeBar />
      <ThreeExperiences />
      <GetStarted />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
